import React, { ReactElement, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Form, InputProps, Select, Input } from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';

import { testId } from 'dogpark/utilities/test/datatestId';
import { BreedersSearchBy, DogParkRoutes } from 'dogpark/utilities/const';
import { BreedersRouteParams } from 'dogpark/types';

import { BreedersSearchContent } from './BreedersSearch.styles';

const { Option } = Select;
const { Search } = Input;

const searchOptions = [
  {
    name: 'Breeder Id',
    value: BreedersSearchBy.BreederId,
  },
  {
    name: 'Breeder Admin Id',
    value: BreedersSearchBy.BreederAdminId,
  },
];

function BreedersSearch(): ReactElement {
  const [inputType, setInputType] = useState<InputProps['type']>('number');
  const [form] = Form.useForm();
  const history = useHistory();
  const { searchBy, searchValue } = useParams<BreedersRouteParams>();
  const { pathname } = useLocation();

  const handleOnFieldsChange = (changedFields: FieldData[]) => {
    const [{ name, value }] = changedFields;

    if (typeof name === 'object') {
      if (name[0] === 'searchBy') {
        handleSetInputType(value);
      }
    }
  };

  const handleSetInputType = (value: string) => {
    if (
      value === BreedersSearchBy.BreederId ||
      value === BreedersSearchBy.BreederAdminId
    ) {
      setInputType('number');
    }
  };

  const handleOnSearch = (value: string) => {
    const fieldSearchBy = form.getFieldValue('searchBy');

    if (fieldSearchBy === BreedersSearchBy.BreederId) {
      value
        ? history.push(`${DogParkRoutes.Breeders}/${fieldSearchBy}/${value}`)
        : history.push(DogParkRoutes.Breeders);
    }

    if (fieldSearchBy === BreedersSearchBy.BreederAdminId) {
      value
        ? history.push(`${DogParkRoutes.BreederAdminUsers}/${fieldSearchBy}/${value}`)
        : history.push(DogParkRoutes.BreederAdminUsers);
    }
  };

  useEffect(() => {
    if (searchBy || searchValue) {
      form.setFieldsValue({ searchBy, searchValue });
    } else {
      form.resetFields();
    }
  }, [searchBy, searchValue]);

  useEffect(() => {
    if (pathname === DogParkRoutes.Breeders) {
      form.setFieldsValue({ searchBy: BreedersSearchBy.BreederId });
    } else if (pathname === DogParkRoutes.BreederAdminUsers) {
      form.setFieldsValue({ searchBy: BreedersSearchBy.BreederAdminId });
    } else {
      form.setFieldsValue({ searchBy: BreedersSearchBy.BreederId });
    }
  }, [pathname]);

  return (
    <BreedersSearchContent data-testid={testId.breedersSearch}>
      <Form layout="inline" form={form} onFieldsChange={handleOnFieldsChange}>
        <Form.Item name="searchBy" className="search-by">
          <Select placeholder="Search by" data-testid={testId.breedersSearchBySelect}>
            {searchOptions.map((option) => (
              <Option value={option.value} key={option.value}>
                {option.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="searchValue" className="search-value">
          <Search
            data-testid={testId.breedersSearchValueInput}
            placeholder="Search"
            allowClear
            onSearch={handleOnSearch}
            type={inputType}
            autoComplete="off"
          />
        </Form.Item>
      </Form>
    </BreedersSearchContent>
  );
}

export default BreedersSearch;
